const JSONToCSVDownload = (jsonArray, filename = "data.csv") => {
  if (!Array.isArray(jsonArray)) return false;

  const fields = Object.keys(jsonArray[0]);
  const replacer = function (key, value) {
    return value === null ? "" : value;
  };
  let csv = jsonArray.map(function (row) {
    return fields
      .map(function (fieldName) {
        if (fieldName.endsWith("Special")) {
          return permissionGenerator(row[fieldName]);
        }
        return JSON.stringify(row[fieldName], replacer);
      })
      .join(",");
  });
  csv.unshift(fields.join(",").replaceAll("Special", "")); // add header column
  csv = csv.join("\r\n");
  
  const csvFile = new Blob([csv], { type: "text/csv" });
  const downloadLink = document.createElement("a");
  downloadLink.download = filename;
  downloadLink.href = window.URL.createObjectURL(csvFile);
  downloadLink.style.display = "none";
  
  document.body.appendChild(downloadLink);
  downloadLink.click();
};

const permissionGenerator = (obj) => {
  const services = Object.keys(obj)
    .map((service) =>
      Object.entries(obj[service])
        .filter((permission) => permission[1] === true)
        .map((filteredPermission) => filteredPermission[0])
        .map((filteredPermission) => `${service}:${filteredPermission}`)
    )
    .flat();
  return services.join(" | ");
};

export { JSONToCSVDownload };
